import styled from 'styled-components';

export const ContainerDesktop = styled.div`
    grid-area: L;
    width: 100%;
    ${({ marginTop }) => marginTop && `margin-top: 1rem;`}

    > * {
        margin-top: 1rem;

        &:first-of-type {
            margin-top: 0;
        }
    }
`;
